(function () {
  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init() {
    var grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.klCollectionReady === 'true' || typeof window.gsap === 'undefined') return;
    grid.dataset.klCollectionReady = 'true';

    if (reducedMotion()) return;

    var items = grid.querySelectorAll('[data-kl-collection-animate]');
    if (!items.length) return;

    window.gsap.fromTo(
      items,
      { autoAlpha: 0, y: 24 },
      { autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.06, ease: 'power3.out' }
    );
  }

  function loadGsap(callback) {
    if (window.gsap) {
      callback();
      return;
    }

    var existing = document.querySelector('script[data-kevilaguGsap]');
    if (existing) {
      existing.addEventListener('load', callback, { once: true });
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    script.defer = true;
    script.dataset.kevilaguGsap = 'true';
    script.addEventListener('load', callback, { once: true });
    document.head.appendChild(script);
  }

  function boot() {
    loadGsap(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
